import { SmartFeedEntityDynamicElementMixin } from "%/dynamic-component-editor/mixins/smart-feed-entity-dynamic-element-mixin";
import { useFanPublicationStore } from "%/dynamic-component-editor/stores/fan-publication-store";
import LoginState from "%/dynamic-component-editor/options/login-state";
export const PageHeaderElementMixin = {
  extends: SmartFeedEntityDynamicElementMixin,
  data() {
    return {
      LoginState,
    };
  },
  methods: {
    getExampleEntity() {
      return this.getRealEntity();
    },
    async getRealEntity() {
      return {
        "publicationName": useFanPublicationStore().publicationName,
        "publicationLogo": useFanPublicationStore().publicationLogo,
        "showUpsellBanner": true,
      };
    },
  },
};
